/**
 * Locked Job View Component
 * 
 * Shows when user doesn't have access to a private job
 * Displays locked icon, explanation, and request access button
 */

import React from 'react';
import RequestAccessButton from '../requests/RequestAccessButton';
import './LockedJobView.css';

const LockedJobView = ({ job, user, onRequestSent }) => {
  return (
    <div className="locked-job-view">
      <div className="locked-container">
        {/* Lock Icon */}
        <div className="lock-icon">🔒</div>

        {/* Title */}
        <h2>Access Required</h2>

        {/* Explanation */}
        <div className="locked-explanation">
          <p>This analysis is from a private casefile and requires permission to view.</p>
          
          <div className="what-you-need">
            <strong>To access this content, you can:</strong>
            <ul>
              <li>Request free access from the owner</li>
              {job.forSale && <li>Purchase access for ${job.accessPrice}</li>}
            </ul>
          </div>
        </div>

        {/* Preview Info (what they'd get) */}
        <div className="access-includes">
          <h3>Access includes:</h3>
          <ul>
            <li>✓ Full AI analysis results</li>
            <li>✓ Video playback</li>
            <li>✓ Data export capabilities</li>
            <li>✓ Screenshot & frame capture</li>
          </ul>
        </div>

        {/* Action Buttons */}
        <div className="locked-actions">
          <RequestAccessButton 
            job={job}
            user={user}
            hasAccess={false}
            onRequestSent={onRequestSent}
          />
          
          {job.forSale && (
            <button className="purchase-btn" disabled>
              💳 Purchase for ${job.accessPrice}
              <span className="coming-soon">(Coming Soon)</span>
            </button>
          )}
        </div>

        {/* Additional Info */}
        <div className="locked-footer">
          <p className="info-text">
            <strong>About access requests:</strong> The owner will be notified and can 
            approve or deny your request. Free access can be revoked by the owner at any time.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LockedJobView;

